import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private http: HttpClient) { }

  getInstaFeed(): Observable<any> {
    return this.http.get('https://www.instagram.com/p/fA9uwTtkSN/?utm_source=ig_embed\u0026amp;utm_campaign=loading', {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    });
  }

}
